(function(){
  if (window.__cenComplArrowsBound) return; window.__cenComplArrowsBound = true;
  function page(inner, dir){
    var max = inner.scrollWidth - inner.clientWidth;
    var target = Math.max(0, Math.min(inner.scrollLeft + dir * inner.clientWidth, max));
    inner.scrollLeft = target;
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('.complementary-products--has-arrows .flickity-nav');
    if (!btn) return;
    e.preventDefault();
    var vp = btn.closest('.complementary-products--viewport');
    var inner = vp && vp.querySelector('.complementary-products--inner');
    if (!inner) return;
    page(inner, btn.classList.contains('flickity-next') ? 1 : -1);
  }, false);
})();
